import React, { useEffect } from "react";
import { Box, Flex } from "@chakra-ui/react";
import { NotificationStyle } from "./components/NotificationStyle";
import { getNotification } from "./services/getNotification";
import { useState } from "react";
import FullPageLoader from "../../components/fullPageLoader";
import { Pagination } from "../../components/Pagination";

export const Notification = () => {
  const [notification, setNotification] = useState([]);
  const [loading, setLoading] = useState(true);
  const [refresh, setRefresh] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [recordPerPage] = useState(10);
  const displayedNotifications = notification;

  const indexOfLastRecord = currentPage * recordPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordPerPage;
  const currentRecord = displayedNotifications.slice(
    indexOfFirstRecord,
    indexOfLastRecord,
  );

  //Change Page
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  useEffect(() => {
    getNotification(setNotification, setLoading);
  }, [refresh]);

  return loading ? (
    <FullPageLoader />
  ) : (
    <Box mx="15px">
      <NotificationStyle
        notification={displayedNotifications}
        setRefresh={setRefresh}
        currentRecord={currentRecord}
      />
      <Flex justifyContent="flex-end">
        <Pagination
          dataPerPage={recordPerPage}
          totalData={displayedNotifications?.length}
          currentPage={currentPage}
          paginate={paginate}
        />
      </Flex>
    </Box>
  );
};
